import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=2524dfb7&scoped=true&functional=true&"
import script from "./SubMenu.vue?vue&type=script&lang=js&"
export * from "./SubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2524dfb7",
  null
  
)

export default component.exports